/**
 * Utilitaires pour la gestion des fichiers
 * Compatible iPhone/iPad/Safari (blob URLs en popup ne fonctionnent pas)
 */

const _isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) || 
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

const _isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

/**
 * Affiche un blob dans un overlay plein écran (fallback iOS / popup bloquée)
 */
const _showInOverlay = (url) => {
  // Remove existing overlay if any
  const existing = document.getElementById('blob-viewer-overlay');
  if (existing) existing.remove();

  const overlay = document.createElement('div');
  overlay.id = 'blob-viewer-overlay';
  overlay.style.cssText = 'position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.85);display:flex;flex-direction:column;';

  const toolbar = document.createElement('div');
  toolbar.style.cssText = 'display:flex;justify-content:space-between;align-items:center;padding:10px 16px;background:#1e293b;flex-shrink:0;';

  const title = document.createElement('span');
  title.textContent = 'Document';
  title.style.cssText = 'color:white;font-size:14px;font-weight:600;';

  const closeBtn = document.createElement('button');
  closeBtn.textContent = 'Fermer';
  closeBtn.style.cssText = 'color:white;background:#ef4444;border:none;padding:8px 20px;border-radius:8px;cursor:pointer;font-size:14px;font-weight:600;';
  closeBtn.onclick = () => { overlay.remove(); URL.revokeObjectURL(url); };

  toolbar.appendChild(title);
  toolbar.appendChild(closeBtn);

  const iframe = document.createElement('iframe');
  iframe.src = url;
  iframe.style.cssText = 'flex:1;border:none;background:white;width:100%;';

  overlay.appendChild(toolbar);
  overlay.appendChild(iframe);
  document.body.appendChild(overlay);
};

export const openBlobInNewTab = (blob) => {
  const url = URL.createObjectURL(blob);

  // Sur iOS/Safari: utiliser l'overlay (window.open bloqué en contexte async)
  if (_isIOS() || _isSafari()) {
    _showInOverlay(url);
    return;
  }

  // Desktop: essayer d'ouvrir un nouvel onglet
  const newWindow = window.open(url, '_blank');
  if (!newWindow || newWindow.closed) {
    _showInOverlay(url);
  } else {
    setTimeout(() => URL.revokeObjectURL(url), 120000);
  }
};

export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename || 'document';
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }, 1000);
};

export const base64ToBlob = (base64, contentType) => {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  return new Blob([new Uint8Array(byteNumbers)], { type: contentType || 'application/octet-stream' });
};
